import ticketDetails from '../localization-messages/ticketDetails/fi-FI.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/fi-FI.json';
import ticketListing from '../localization-messages/ticketListing/fi-FI.json';
import ticketForm from '../localization-messages/ticketForm/fi-FI.json';
import headerFooter from '../localization-messages/headerFooter/fi-FI.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/fi-FI.json';
import termsModal from '../localization-messages/termsModal/fi-FI.json';

export const fiFITranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
